// extracted by mini-css-extract-plugin
export default {"pageContainer":"Layout_pageContainer__e-e8z"};